import { gql } from "@apollo/client"

export const ENGAGEMENTS = gql`
  query Engagements(
    $staff_id: ID
    $idTemplate: ID!
    $participant_membership_id: ID
  ) {
    engagements: blocksSavedByIdTemplate(
      staff_id: $staff_id
      idTemplate: $idTemplate
      participant_membership_id: $participant_membership_id
      groupByIdStamp: true
    ) {
      data
    }
  }
`

export const NOTES_PARTICIPANT = gql`
  query NotesParticipant(
    $participant_id: ID!
    $organization_id: ID!
    $idTemplate: ID!
    $staff_id: ID!
    $participant_membership_id: ID!
  ) {
    engagementsParticipant: blocksSavedByParticipantIdTemplate(
      participant_id: $participant_id
      organization_id: $organization_id
      idTemplate: $idTemplate
      groupByIdStamp: true
    ) {
      data
      __typename
    }
    participant(
      participant_id: $participant_id
      organization_id: $organization_id
    ) {
      staff_full_name
      __typename
    }
    serviceEpisode: getMaxServiceEpisode(
      staff_id: $staff_id
      organization_id: $organization_id
      participant_membership_id: $participant_membership_id
      participant_id: $participant_id
    ) {
      service_episodes_id
    }
  }
`

export const TEMPLATE_STATS = gql`
  query templateStats($participant_membership_id: ID, $staff_id: String) {
    stats: getSpecificBlocksStatsByMembership(
      participant_membership_id: $participant_membership_id
      blocks: ["session", "session__recovery_plan", "session__group_session"]
    ) {
      data
    }
    engagements: getSpecificBlocksByMembership(
      participant_membership_id: $participant_membership_id
      blocks: ["session", "session__recovery_plan", "session__group_session"]
    ) {
      data
    }
    templateNames: templates(type: "system", staff_id: $staff_id) {
      template_name
      template_title
    }
  }
`
export const ENGAGEMENTS_PARTICIPANT_GROUP_BY_TEMPLATE = gql`
  query EngagementsParticipant(
    $participant_id: ID!
    $organization_id: ID!
    $idTemplates: [ID]
    $idBlocks: [ID]
    $participant_membership_id: ID
  ) {
    engagementsParticipant: getAllParticipantBlocksGroupByIdTemplate(
      participant_id: $participant_id
      organization_id: $organization_id
      idTemplates: $idTemplates
      idBlocks: $idBlocks
      participant_membership_id: $participant_membership_id
      groupByIdStamp: true
    ) {
      data
    }
  }
`

export const ENGAGEMENTS_COUNT = gql`
  query GetEngagements($participant_membership_id: ID!) {
    engagementsKpi(participant_membership_id: $participant_membership_id) {
      data
    }
  }
`

export const ENGAGEMENTS_CHART = gql`
  query GetEngagementsDate(
    $participant_membership_id: ID!
    $query_type: String!
    $numberOfDays: Int
    $year: String
  ) {
    engagementsKpiPerDate(
      participant_membership_id: $participant_membership_id
      query_type: $query_type
      numberOfDays: $numberOfDays
      year: $year
    ) {
      data
    }
  }
`
export const GET_LABEL = gql`
  query GetLabelChart($parent: String!, $enterprise_id: ID!) {
    label(parent: $parent, enterprise_id: $enterprise_id) {
      data
    }
  }
`
